// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__cC3Af","footerImage":"styles_footerImage__pyHnc","footerText":"styles_footerText__CAANK","customFontSize":"styles_customFontSize__DUNlE"};